import { Course } from '@/store/modules/enrollment/state';
import Vue from 'vue';
import { VueGtag } from 'vue-gtag';
import { PaymentInfoTrackingModel } from './paymentInfoTracking';

const EMAIL_ALIAS = 'used_mixpanel_email_alias';

interface AnalyticsTrackingProps extends PaymentInfoTrackingModel {
  paymentMethod: string;
  isRecurrentCreditCard: boolean;
  email: string;
  academicRecordId: string;
}

// DEPRECATED
class Analytics {
  static identify({ id, email, name }: { id: string; email?: string; name?: string }) {
    if (window.POCKET) {
      const accountsUser = window.POCKET.profile();
      const isSameAccountsUser = id === accountsUser?.email;

      if (isSameAccountsUser) {
        window.POCKET.alias(accountsUser.id.toString());
      }
      if ((isSameAccountsUser || !accountsUser) && !Vue.$cookies.get(EMAIL_ALIAS)) {
        window.POCKET.alias(id);
        Vue.$cookies.set(EMAIL_ALIAS, true, '1m', '/', '.descomplica.com.br');
      }
      window.POCKET.identify(id, { email, name, $email: email });
    }
  }

  static reset() {
    if (window.POCKET) window.POCKET.profile.reset();
  }

  static profile(): { email?: string } {
    if (window.POCKET) return window.POCKET.profile();
    return {};
  }

  static track(eventName: string, props: Object = {}): void {
    if (window.POCKET)
      window.POCKET.track(eventName, {
        business_category: 'faculdade',
        category: 'faculdade',
        useMixpanel: true,
        useHubspot: true,
        ...props,
      });
  }

  static getRawUrl(): string {
    const { host, pathname } = window.location;
    return `${host}${pathname}`;
  }

  static trackPageView() {
    Analytics.trackMixpanel('Page View', { gt_Location: this.getRawUrl() });
  }

  static trackMixpanel(eventName: string, props: Object = {}) {
    Analytics.track(eventName, { useHubspot: false, ...props });
  }

  static trackHubSpot(eventName: string, props: Object = {}) {
    Analytics.track(eventName, { useMixpanel: false, ...props });
  }

  static trackEcommerceTransaction(
    enrollmentId: string,
    course: Course,
    props: Partial<AnalyticsTrackingProps> = {
      course: undefined,
    },
  ) {
    const gtag: VueGtag = (Vue as any).$gtag;

    const transactionId = `${Date.now()}_${enrollmentId}`;
    const { course: removed, ...rest } = props;
    gtag.purchase({
      transaction_id: transactionId,
      items: [{ id: `FAC-PS-CURSO-${course?.id}`, name: course?.name, quantity: 1, ...rest }],
    });
  }
}

export default Analytics;
